import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import Waveform from "@/components/Waveform";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password, remember);
    setLoading(false);
    if (res.ok) navigate("/account");
    else setError(res.error);
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md">
        <p className="eyebrow mb-3">Welcome back</p>
        <h1 className="font-anton uppercase text-5xl sm:text-6xl leading-none mb-8">Sign in</h1>
        <Waveform color="rgb(var(--graphite))" className="mb-10" />
        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
          </div>
          <div>
            <div className="flex justify-between items-center mb-2">
              <label className="eyebrow">Password</label>
              <Link to="/forgot-password" data-testid="forgot-password-link"
                className="font-mono text-[11px] uppercase tracking-wider text-graphite hover:text-pulse">Forgot?</Link>
            </div>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full bg-transparent border-b border-border py-3 font-mono text-sm focus:border-pulse outline-none" />
          </div>
          <label className="flex items-center gap-3 cursor-pointer select-none" data-testid="login-remember-label">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)}
              data-testid="login-remember-checkbox"
              className="h-4 w-4 cursor-pointer" style={{ accentColor: "rgb(var(--signal))" }} />
            <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-graphite">
              Remember my login — stay connected for 30 days
            </span>
          </label>
          {error && <p className="text-destructive font-mono text-xs" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-pulse w-full disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-8 text-graphite text-sm font-mono">
          No account? <Link to="/register" className="text-chalk hover:text-pulse link-underline">Create one</Link>
        </p>
      </motion.div>
    </div>
  );
}
